<template>
  <div class="map-container">
    <div class="left">
      <h1>{{$t('track.trackMap.h1')}}</h1>
      <p>
        &emsp;&emsp;{{$t('track.trackMap.p')}}
      </p>
      <div class="button" @click="goAbout">{{$t('track.trackMap.more')}}</div>
    </div>

    <div class="right">
      <img src="../../../assets/images/track/car-01.jpg" alt="" />
      <img src="../../../assets/images/track/car-02.jpg" alt="" />
      <img src="../../../assets/images/track/car-03.jpg" alt="" />
      <img src="../../../assets/images/track/car-04.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goAbout() {
      this.$router.push("/about");
    },
  },
};
</script>

<style lang="less" scoped>
.map-container {
  padding: 48px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .left {
    width: 560px;
    height: 500px;
    h1 {
      font-weight: bold;
      color: #ff5d1b;
    }
  }
  .right {
    width: 760px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    // background-color: pink;
    img {
      padding: 24px;
      width: 360px;
      // border-radius: 12px;
      // border: 1px solid #ff5d1b;
      // height: 200px;
    }
  }
}

.button {
  margin-top: 48px;
  width: 240px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  background-color: #ff5d1b;
  cursor: pointer;
  transition-property: background-color;
  transition-delay: 0.15s;

  &:hover {
    background-color: rgba(247, 64, 9, 0.918);
  }
}
</style>